import React, { useEffect, useState } from "react";
import dashboardImg from "../../assets/img/admin-message.png";
import appStoreBtn from "../../assets/img/generic/app-store.png";
import googlePlayBtn from "../../assets/img/generic/play-store.png";
import visitorDashboardBanner from "../../assets/img/visitordashboardbanner.jpg";
import { LineChart } from "../../components/charts/Line";
import DoughnutChart from "../../components/charts/Doughnut";
import { BarChart } from "../../components/charts/Bar";
import { get } from "../../services/api";
import DataTable from "react-data-table-component";
import { customTableStyles } from "../../assets/CustomTableStyles";

import { Link, useNavigate } from "react-router-dom";
import ParentStudentDashboard from "./ParentStudentDashboard";
import FullScreenLoader from "../../components/FullScreenLoader";
import BookedAssessments from "../assessment/BookedAssessments";
import SetShowCenterModal from "./SetShowCenterModal";
import { useForm, Controller, useWatch } from "react-hook-form";
import Select from "react-select";
import { Doughnut, Bar, Line } from "react-chartjs-2";

// Import new components
import FinanceDashboard from "./FinanceDashboard";
import HumanResourceDashboard from "./HumanResourceDashboard";
import StudentSummaryModal from "./StudentSummaryModal";
import WithdrawalSummaryModal from "./WithdrawalSummaryModal";

// Import Chart.js components
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

function InspSchoolManagementDashboard() {
  const token = localStorage.getItem("token");
  const accountString = localStorage.getItem("accountString");

  const userId = localStorage.getItem("userId");
  const roleId = localStorage.getItem("roleId");

  const organizationId =
    localStorage.getItem("organizationId") === "null" ||
    localStorage.getItem("organizationId") === "0"
      ? 0
      : localStorage.getItem("organizationId");

  const centerId =
    localStorage.getItem("centerId") === "0" ||
    localStorage.getItem("centerId") === "null"
      ? 0
      : localStorage.getItem("centerId");

  const navigate = useNavigate();
  const [dashboardData, setDashboardData] = useState(null);
  const [registrationsData, setRegistrationsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCalendar, setShowCalendar] = useState(false);
  const [showCenterSetModal, setshowCenterModal] = useState(true);
  const [hoveredChart, setHoveredChart] = useState(null);
  const [animated, setAnimated] = useState(false);

  const [activeTab, setActiveTab] = useState("mis");
  const [showStudentSummary, setShowStudentSummary] = useState(false);
  const [showWithdrawalSummary, setShowWithdrawalSummary] = useState(false);

  // Chart data states (only needed for MIS)
  const [ticketsChartData, setTicketsChartData] = useState(null);

  // Static chart data – will be replaced with real API later if needed
  const [chartData] = useState({
    enrollmentByGrade: {
      labels: [
        "Nursery",
        "KG",
        "Grade 1",
        "Grade 2",
        "Grade 3",
        "Grade 4",
        "Grade 5",
        "Grade 6",
        "Grade 7",
        "Grade 8",
      ],
      data: [120, 180, 200, 190, 170, 160, 150, 140, 130, 110],
      colors: [
        "#3498db",
        "#2980b9",
        "#1f618d",
        "#1a5276",
        "#154360",
        "#3498db",
        "#2980b9",
        "#1f618d",
        "#1a5276",
        "#154360",
      ],
    },
    averageScores: [
      { subject: "Math", score: 82, color: "#3498db" },
      { subject: "Science", score: 78, color: "#2ecc71" },
      { subject: "English", score: 85, color: "#e74c3c" },
      { subject: "Urdu", score: 88, color: "#f39c12" },
      { subject: "CS", score: 75, color: "#9b59b6" },
      { subject: "Islamiyat", score: 90, color: "#1abc9c" },
    ],
  });

  // Filter Form
  const { control, setValue } = useForm({
    defaultValues: {
      provinceId: null,
      cityId: null,
      centerId: null,
      classId: null,
      sessionId: null,
    },
  });

  const [provincesData, setProvincesData] = useState([]);
  const [citiesData, setCitiesData] = useState([]);
  const [centersData, setCentersData] = useState([]);
  const [classesData, setClassesData] = useState([]);
  const [sessionsData, setSessionsData] = useState([]);

  const selectedProvince = useWatch({ control, name: "provinceId" });
  const selectedCity = useWatch({ control, name: "cityId" });
  const selectedCenter = useWatch({ control, name: "centerId" });
  const selectedClass = useWatch({ control, name: "classId" });
  const selectedSession = useWatch({ control, name: "sessionId" });

  // ==================== FETCH FUNCTIONS ====================
  const fetchProvincesData = async () => {
    try {
      const response = await get(
        `Dashboard/GetSatateByOrganizationId?organizationId=${organizationId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setProvincesData(response || []);
    } catch (error) {
      console.error("Error fetching provinces:", error);
    }
  };

  const fetchCitiesByProvinceCode = async (stateCode) => {
    if (!stateCode) {
      setCitiesData([]);
      return;
    }
    try {
      const code = typeof stateCode === "object" ? stateCode.code : stateCode;

      const response = await get(`Dashboard/GetCityByStateCode?code=${code}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCitiesData(response || []);
    } catch (error) {
      console.error("Error fetching cities by province code:", error);
      setCitiesData([]);
    }
  };

  const fetchCentersByCityCode = async (cityCode) => {
    if (!cityCode) {
      setCentersData([]);
      return;
    }
    try {
      const response = await get(
        `Dashboard/GetCenterByCityCode?code=${cityCode}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCentersData(response || []);
    } catch (error) {
      console.error("Error fetching centers by city code:", error);
      setCentersData([]);
    }
  };

  const fetchAllCenters = async () => {
    try {
      const response = await get(
        `Dashboard/GetAllCentersByOrganizationId?organizationId=${organizationId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCentersData(response || []);
      // Pre-select for roleId 3
      if (roleId === "3" && centerId && centerId !== "0") {
        const selected = response.find((c) => c.id === parseInt(centerId));
        if (selected) {
          setValue("centerId", { value: selected.id, label: selected.name });
        }
      }
    } catch (error) {
      console.error("Error fetching all centers:", error);
    }
  };

  const fetchClassesByCenterId = async (cId) => {
    if (!cId) {
      setClassesData([]);
      return;
    }
    try {
      const response = await get(
        `CenterClass/GetClassCenterByCenterId?id=${cId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setClassesData(response || []);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  const fetchCenterSessions = async (cId) => {
    try {
      const response = await get(
        `FeePlan/GetCenterSessionsByOrganizationId?id=${cId}&organizationId=${organizationId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const sessions = response.centerSessions || [];
      setSessionsData(sessions);
      if (sessions.length > 0) {
        const first = sessions[0];
        const option = {
          value: first.id,
          label: first.name || first.sessionName,
        };
        setValue("sessionId", option);
      } else {
        setValue("sessionId", null);
      }
    } catch (error) {
      console.error("Error fetching center sessions:", error);
      setSessionsData([]);
      setValue("sessionId", null);
    }
  };

  // ==================== EFFECTS ====================
  useEffect(() => {
    if (roleId === "2") {
      fetchProvincesData();
      fetchCenterSessions(selectedCenter?.value || 0);
    } else if (roleId === "3") {
      const code = accountString.split("-")[1];
      fetchCentersByCityCode(code);

      // Find the center in centersData
      const centerToSelect = centersData.find(
        (c) => c.id === parseInt(centerId) || c.value === parseInt(centerId)
      );

      if (centerToSelect) {
        // Use setValue to update the form
        setValue("centerId", {
          value: centerToSelect.id || centerToSelect.value,
          label: centerToSelect.code || centerToSelect.code,
        });
      }
      setValue("centerId", centerToSelect);
      fetchCenterSessions(selectedCenter?.value || 0);

      getDashboardData();
    }
  }, []);

  useEffect(() => {
    if (roleId === "3" && centersData.length > 0) {
      const centerToSelect = centersData.find(
        (c) => c.id === parseInt(centerId) || c.value === parseInt(centerId)
      );

      if (centerToSelect) {
        setValue("centerId", {
          value: centerToSelect.id || centerToSelect.value,
          label: centerToSelect.code || centerToSelect.name,
        });

        fetchCenterSessions(centerToSelect.id || centerToSelect.value || 0);
      }
    }
  }, [centersData, roleId, centerId]);

  useEffect(() => {
    if (roleId === "2" && selectedProvince?.code) {
      fetchCitiesByProvinceCode(selectedProvince.code);
      // Reset dependent dropdowns
      setValue("cityId", null);
      setValue("centerId", null);
      setValue("classId", null);
      setCitiesData([]);
      setCentersData([]);
      setClassesData([]);
    }
  }, [selectedProvince, roleId]);

  useEffect(() => {
    console.log(selectedCity);
    if (roleId === "2" && selectedCity?.code) {
      fetchCentersByCityCode(selectedCity.code);
      // Reset dependent dropdowns
      setValue("centerId", null);
      setValue("classId", null);
      setCentersData([]);
      setClassesData([]);
    }
  }, [selectedCity, roleId]);

  useEffect(() => {
    if (selectedCenter?.value) {
      fetchCenterSessions(selectedCenter.value);
      fetchClassesByCenterId(selectedCenter.value);
    } else {
      setClassesData([]);
      setValue("classId", null);
      // Fetch sessions for organization (id=0) when no center is selected to keep session selected
      fetchCenterSessions(0);
    }
  }, [selectedCenter]);

  // ==================== DASHBOARD DATA ====================
  const getDashboardData = async () => {
    if (!token) return;

    try {
      const selectedCenterId = selectedCenter?.value || centerId || 0;
      const selectedClassId = selectedClass?.value || 0;
      const selectedSessionId = selectedSession?.value || 0;
      const stateCode = selectedProvince?.code || "";
      const cityCode = selectedCity?.code || "";

      const response = await get(
        `Dashboard/GetAllDashboardStudentStaffRevenueAndCampusAsync?organizationID=${organizationId}&centerId=${selectedCenterId}&classId=${selectedClassId}&sessionId=${selectedSessionId}&stateCode=${stateCode}&cityCode=${cityCode}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setDashboardData(response);
    } catch (error) {
      console.error("Error fetching Dashboard Data:", error);
    } finally {
      setLoading(false);
    }
  };
  
  const getRegistrationsList = async () => {
    if (!token) return;
    setLoading(true);
    try {
      const response = await get(
        `Student/GetPupilsInformationByUserId?userId=${userId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setRegistrationsData(response || []);
    } catch (error) {
      console.error("Error fetching Registrations:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (roleId === "11") {
      getRegistrationsList();
    } else if (roleId === "9" || roleId === "10") {
      const getStudentsByParentId = async () => {
        try {
          const studentResponse = await get(
            `Student/GetStudentByParentIdAsync?userId=${userId}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          if (studentResponse && studentResponse.length > 0) {
            navigate("/parent-student-dashboard");
          }
        } catch (error) {
          console.error("Error fetching student data:", error);
        }
      };
      getStudentsByParentId();
    } else {
      getDashboardData();
    }
    if (roleId === "2") {
      setshowCenterModal(true);
    }
  }, [
    roleId,
    userId,
    token,
    organizationId,
    centerId,
    selectedCenter,
    selectedClass,
    selectedSession,
    selectedProvince,
    selectedCity,
    navigate,
  ]);

  useEffect(() => {
    if (roleId === "11" && registrationsData.length > 0) {
      navigate("/application-status");
    }
  }, [registrationsData, roleId, navigate]);

  useEffect(() => setAnimated(true), []);

  // ==================== TICKETS CHART SETUP ====================
  useEffect(() => {
    const summary = dashboardData?.summaryStatistics?.[0];
    const ticketsData = {
      labels: ["Open", "Resolved", "In Progress"],
      datasets: [
        {
          data: [
            summary?.openTicketCount || 0,
            summary?.resolvedTicketCount || 0,
            summary?.inProgressTicketCount || 0,
          ],
          backgroundColor: ["#e74c3c", "#2ecc71", "#f39c12"],
          borderWidth: 2,
          hoverOffset: 15,
          borderRadius: 8,
          spacing: 4,
        },
      ],
    };
    const ticketsOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: "bottom",
          labels: {
            padding: 20,
            usePointStyle: true,
            pointStyle: "circle",
            font: { size: 11, weight: "600" },
          },
        },
      },
      cutout: "65%",
    };
    setTicketsChartData({ data: ticketsData, options: ticketsOptions });
  }, [dashboardData]);

  // ==================== EMPLOYEES DATA ====================
  const employeesByDepartment = {
    labels: [
      "Teachers",
      "Administration",
      "Accounts",
      "Academic",
      "Franchise",
      "Staff",
    ],
    data: [
      dashboardData?.summaryStatistics?.[0]?.teacherCount || 0,
      dashboardData?.summaryStatistics?.[0]?.administrationCount || 0,
      dashboardData?.summaryStatistics?.[0]?.accountsCount || 0,
      dashboardData?.summaryStatistics?.[0]?.academicCount || 0,
      dashboardData?.summaryStatistics?.[0]?.franchiseCount || 0,
      dashboardData?.summaryStatistics?.[0]?.staffCount || 0,
    ],
    colors: ["#9b59b6", "#8e44ad", "#7d3c98", "#6c3483", "#5b2c6f", "#4a235a"],
  };

  // ==================== CHART RENDERERS ====================
  const renderEnrollmentChart = () => {
    const gradeData = dashboardData?.studentStrengthComparisonGradeWise || [];
    const labels = gradeData.map((item) => item.class);
    const data = gradeData.map((item) => item.student_Strength);
    const colors = chartData.enrollmentByGrade.colors;

    // Calculate maxValue with fallback to avoid division by zero
    const calculatedMax = Math.max(...data, 0); // 0 is default if all are negative
    const maxValue = calculatedMax > 0 ? calculatedMax : 1; // fallback to 1 if max <= 0

    return (
      <div style={{ height: "250px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
            height: "200px",
            padding: "0 10px",
          }}
        >
          {data.map((value, index) => (
            <div
              key={index}
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
              onMouseEnter={() =>
                setHoveredChart({ type: "enrollment", index })
              }
              onMouseLeave={() => setHoveredChart(null)}
            >
              <div
                style={{
                  fontSize: "11px",
                  fontWeight: "600",
                  marginBottom: "5px",
                  opacity:
                    hoveredChart?.type === "enrollment" &&
                    hoveredChart?.index === index
                      ? 1
                      : 0.7,
                }}
              >
                {value}
              </div>
              <div
                style={{
                  height: "150px",
                  width: "20px",
                  backgroundColor: "rgba(52,152,219,0.1)",
                  borderRadius: "4px 4px 0 0",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    bottom: 0,
                    width: "100%",
                    height: animated ? `${(value / maxValue) * 100}%` : "0%",
                    backgroundColor: colors[index % colors.length],
                    borderRadius: "4px 4px 0 0",
                    transition: "height 1.5s ease",
                  }}
                />
              </div>
              <div
                style={{
                  fontSize: "10px",
                  marginTop: "8px",
                  fontWeight: "600",
                }}
              >
                {labels[index]}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };
  const renderEmployeesChart = () => {
    const maxValue = Math.max(...employeesByDepartment.data);
    return (
      <div style={{ height: "250px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
            height: "200px",
            padding: "0 10px",
          }}
        >
          {employeesByDepartment.data.map((value, index) => (
            <div
              key={index}
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
              onMouseEnter={() => setHoveredChart({ type: "employees", index })}
              onMouseLeave={() => setHoveredChart(null)}
            >
              <div style={{ fontSize: "11px", fontWeight: "600" }}>{value}</div>
              <div
                style={{
                  height: "150px",
                  width: `${20 + index * 3}px`,
                  backgroundColor: "rgba(155,89,182,0.1)",
                  borderRadius: "4px 4px 0 0",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    bottom: 0,
                    width: "100%",
                    height: animated ? `${(value / maxValue) * 100}%` : "0%",
                    backgroundColor: employeesByDepartment.colors[index],
                    borderRadius: "4px 4px 0 0",
                    transition: "height 1.5s ease",
                  }}
                />
              </div>
              <div
                style={{
                  fontSize: "10px",
                  marginTop: "8px",
                  fontWeight: "600",
                }}
              >
                {employeesByDepartment.labels[index]}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderAverageScores = () => {
    const data = {
      labels: chartData.averageScores.map((s) => s.subject),
      datasets: [
        {
          data: chartData.averageScores.map((s) => s.score),
          backgroundColor: chartData.averageScores.map((s) => s.color),
          borderRadius: 6,
        },
      ],
    };
    const options = {
      indexAxis: "y",
      responsive: true,
      maintainAspectRatio: false,
      plugins: { legend: { display: false } },
      scales: { x: { max: 100, ticks: { callback: (v) => v + "%" } } },
    };
    return (
      <div style={{ height: "300px" }}>
        <Bar data={data} options={options} />
      </div>
    );
  };

  const renderTicketsChart = () => {
    return ticketsChartData ? (
      <div style={{ height: "250px" }}>
        <Doughnut
          data={ticketsChartData.data}
          options={ticketsChartData.options}
        />
      </div>
    ) : null;
  };

  if (showCalendar) {
    return (
      <BookedAssessments
        heading="Daily Activity"
        onBack={() => setShowCalendar(false)}
      />
    );
  }

  return (
    <>
      {/* Visitor */}
      {roleId === "11" && (
        <>
          {loading ? (
            <FullScreenLoader />
          ) : (
            <div style={{ minHeight: "400px" }}>
              <img
                className="img-fluid"
                src={visitorDashboardBanner}
                alt="Visitor Dashboard Banner"
              />
              <div className="text-end">
                <Link to="/registration-form" className="btn btn-primary mt-3">
                  Apply Now
                </Link>
              </div>
            </div>
          )}
        </>
      )}

      {/* Parent */}
      {(roleId === "9" || roleId === "10") && <ParentStudentDashboard />}

      {/* Main Dashboard */}
      {roleId !== "11" && roleId !== "9" && roleId !== "10" && (
        <>
          {/* Header */}
          <div
            className="mb-2"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <h3
                className="mb-2"
                style={{ color: "#2c3e50", fontWeight: "700" }}
              >
                {dashboardData?.summaryStatistics?.[0]?.name ||
                  "Dashboard & Analytics"}
              </h3>
              <div className="d-flex gap-5 mb-4 border-bottom pb-3">
                <div
                  onClick={() => setActiveTab("mis")}
                  className="cursor-pointer fw-semibold"
                  style={{
                    color: activeTab === "mis" ? "#c0392b" : "#6c757d",
                    borderBottom:
                      activeTab === "mis"
                        ? "3px solid #c0392b"
                        : "3px solid transparent",
                    paddingBottom: "8px",
                    fontSize: "15px",
                  }}
                >
                  MIS
                </div>
                <div
                  onClick={() => setActiveTab("financials")}
                  className="cursor-pointer fw-semibold"
                  style={{
                    color: activeTab === "financials" ? "#c0392b" : "#6c757d",
                    borderBottom:
                      activeTab === "financials"
                        ? "3px solid #c0392b"
                        : "3px solid transparent",
                    paddingBottom: "8px",
                    fontSize: "15px",
                  }}
                >
                  Financials
                </div>
                <div
                  onClick={() => setActiveTab("hr")}
                  className="cursor-pointer fw-semibold"
                  style={{
                    color: activeTab === "hr" ? "#c0392b" : "#6c757d",
                    borderBottom:
                      activeTab === "hr"
                        ? "3px solid #c0392b"
                        : "3px solid transparent",
                    paddingBottom: "8px",
                    fontSize: "15px",
                  }}
                >
                  Human Resource
                </div>
              </div>
            </div>

            {/* Calendar Button */}
            {roleId === "7" && (
              <button
                className="btn btn-primary"
                onClick={() => setShowCalendar(true)}
                style={{
                  backgroundColor: "#3498db",
                  borderColor: "#3498db",
                  fontWeight: "600",
                  padding: "10px 20px",
                  borderRadius: "8px",
                }}
              >
                <i className="fas fa-calendar-alt me-2"></i> View Calendar
              </button>
            )}

            {/* Filters */}
            {/* Role 2: All 5 dropdowns */}
            {/* Role 3: Only 3 dropdowns (Center, Class, Session) */}
            {(roleId === "2" || roleId === "3") && (
              <div className="d-flex justify-content-end mb-4">
                <div className="d-flex align-items-center gap-3 flex-nowrap">
                  {/* Province Dropdown – Only for Role 2 */}
                  {roleId === "2" && (
                    <div>
                      <Controller
                        name="provinceId"
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={provincesData.map((item) => ({
                              value: item.code,
                              label: item.name,
                              code: item.code,
                            }))}
                            onChange={(opt) => {
                              field.onChange(opt);
                              setValue("cityId", null);
                              setValue("centerId", null);
                              setValue("classId", null);
                              setCitiesData([]);
                              setCentersData([]);
                              setClassesData([]);
                            }}
                            isClearable
                            className="react-select-style"
                            classNamePrefix="react-select-style-pref"
                            placeholder="Select Province"
                            styles={{
                              control: (base) => ({
                                ...base,
                                minWidth: "140px",
                                height: "40px",
                                borderRadius: "999px",
                                border: "1px solid #e3e7f0",
                                background: "#ffffff",
                                fontSize: "12px",
                                padding: "0 8px",
                                boxShadow: "none",
                                "&:hover": { borderColor: "#c0392b" },
                              }),
                              placeholder: (base) => ({
                                ...base,
                                color: "#8a94a6",
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color: "#24292f",
                              }),
                              menu: (base) => ({
                                ...base,
                                fontSize: "12px",
                                borderRadius: "8px",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                              }),
                            }}
                          />
                        )}
                      />
                    </div>
                  )}

                  {/* City Dropdown – Only for Role 2 */}
                  {roleId === "2" && (
                    <div>
                      <Controller
                        name="cityId"
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={citiesData.map((item, index) => ({
                              value: `city-${index}`,
                              label: item.name,
                              code: item.code,
                            }))}
                            onChange={(opt) => {
                              field.onChange(opt);
                              setValue("centerId", null);
                              setValue("classId", null);
                              setCentersData([]);
                              setClassesData([]);

                              // Fetch centers when city is selected
                              if (opt?.value) {
                                fetchCentersByCityCode(opt.code);
                              }
                            }}
                            isClearable
                            className="react-select-style"
                            classNamePrefix="react-select-style-pref"
                            placeholder="Select City"
                            isDisabled={!selectedProvince}
                            styles={{
                              control: (base) => ({
                                ...base,
                                minWidth: "140px",
                                height: "40px",
                                borderRadius: "999px",
                                border: "1px solid #e3e7f0",
                                background: "#ffffff",
                                fontSize: "12px",
                                padding: "0 8px",
                                boxShadow: "none",
                                "&:hover": { borderColor: "#c0392b" },
                              }),
                              placeholder: (base) => ({
                                ...base,
                                color: "#8a94a6",
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color: "#24292f",
                              }),
                              menu: (base) => ({
                                ...base,
                                fontSize: "12px",
                                borderRadius: "8px",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                              }),
                            }}
                          />
                        )}
                      />
                    </div>
                  )}
                  {/* Center Dropdown – For Both Role 2 and Role 3 */}
                  <div>
                    <Controller
                      name="centerId"
                      control={control}
                      render={({ field }) => (
                        <Select
                          {...field}
                          value={field.value || null}
                          options={centersData.map((c) => ({
                            value: c.id,
                            label: c.name,
                          }))}
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption);
                            setValue("classId", null);
                            // Session should not be cleared
                          }}
                          className="react-select-style"
                          classNamePrefix="react-select-style-pref"
                          isClearable={roleId === "2"}
                          isDisabled={roleId === "3"}
                          placeholder="Select Center"
                          styles={{
                            control: (base) => ({
                              ...base,
                              minWidth: "140px",
                              height: "40px",
                              borderRadius: "999px",
                              border: "1px solid #e3e7f0",
                              background: "#ffffff",
                              fontSize: "12px",
                              padding: "0 8px",
                              boxShadow: "none",
                              "&:hover": { borderColor: "#c0392b" },
                            }),
                            singleValue: (base) => ({
                              ...base,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "130px",
                              display: "block",
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: "#8a94a6",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }),
                            menu: (base) => ({
                              ...base,
                              fontSize: "12px",
                              borderRadius: "8px",
                              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                            }),
                            option: (base) => ({
                              ...base,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }),
                          }}
                        />
                      )}
                    />
                  </div>

                  {/* Class Dropdown – For Both Role 2 and Role 3 */}
                  <div>
                    <Controller
                      name="classId"
                      control={control}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={classesData.map((cls) => ({
                            value: cls.id,
                            label: cls.name,
                          }))}
                          isClearable
                          placeholder="Select Class"
                          className="react-select-style"
                          classNamePrefix="react-select-style-pref"
                          isDisabled={!selectedCenter}
                          styles={{
                            control: (base) => ({
                              ...base,
                              minWidth: "140px",
                              height: "40px",
                              borderRadius: "999px",
                              border: "1px solid #e3e7f0",
                              background: "#ffffff",
                              fontSize: "12px",
                              padding: "0 8px",
                              boxShadow: "none",
                              "&:hover": { borderColor: "#c0392b" },
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: "#8a94a6",
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color: "#24292f",
                            }),
                            menu: (base) => ({
                              ...base,
                              fontSize: "12px",
                              borderRadius: "8px",
                              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                            }),
                          }}
                        />
                      )}
                    />
                  </div>

                  {/* Session Dropdown – For Both Role 2 and Role 3 */}
                  <div>
                    <Controller
                      name="sessionId"
                      control={control}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={sessionsData.map((s) => ({
                            value: s.id,
                            label: s.sessionName || s.name,
                          }))}
                          isClearable
                          placeholder="Select Session"
                          className="react-select-style"
                          classNamePrefix="react-select-style-pref"
                          styles={{
                            control: (base) => ({
                              ...base,
                              minWidth: "140px",
                              height: "40px",
                              borderRadius: "999px",
                              border: "1px solid #e3e7f0",
                              background: "#ffffff",
                              fontSize: "12px",
                              padding: "0 8px",
                              boxShadow: "none",
                              "&:hover": { borderColor: "#c0392b" },
                            }),
                            singleValue: (base) => ({
                              ...base,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "130px",
                              display: "block",
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: "#8a94a6",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }),
                            menu: (base) => ({
                              ...base,
                              fontSize: "12px",
                              borderRadius: "8px",
                              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                            }),
                            option: (base) => ({
                              ...base,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }),
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* ============= MIS TAB ============= */}
          {activeTab === "mis" && (
            <>
              {/* 4 KPI Tiles */}
              <div className="row g-3 mb-4">
                {/* TOTAL STUDENTS - Clickable */}
                <div
                  className="col-6 col-md-3"
                  onClick={() => setShowStudentSummary(true)}
                  style={{ cursor: "pointer" }}
                >
                  <div
                    className="card rounded-3 p-3 shadow-sm clickable"
                    style={{
                      borderLeft: "4px solid #3498db",
                      transition: "all 0.2s ease",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "translateY(-2px)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "translateY(0)")
                    }
                  >
                    <div className="d-flex align-items-center">
                      <div
                        className="me-3"
                        style={{ color: "#3498db", fontSize: "28px" }}
                      >
                        <i className="fas fa-graduation-cap"></i>
                      </div>
                      <div>
                        <div className="text-uppercase fs-8 text-muted fw-bold">
                          Total Students
                        </div>
                        <div
                          className="h4 mb-0 fw-bold"
                          style={{ color: "#2c3e50" }}
                        >
                          {dashboardData?.summaryStatistics?.[0]
                            ?.studentCount || 0}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* REG TO ADMISSION - Normal */}
                <div className="col-6 col-md-3">
                  <div
                    className="card rounded-3 p-3 shadow-sm"
                    style={{ borderLeft: "4px solid #2ecc71" }}
                  >
                    <div className="d-flex align-items-center">
                      <div
                        className="me-3"
                        style={{ color: "#2ecc71", fontSize: "28px" }}
                      >
                        <i className="fas fa-user-plus"></i>
                      </div>
                      <div>
                        <div className="text-uppercase fs-8 text-muted fw-bold">
                          Reg to Admission
                        </div>
                        <div
                          className="h4 mb-0 fw-bold"
                          style={{ color: "#2c3e50" }}
                        >
                          {dashboardData?.summaryStatistics?.[0]
                            ?.registerdStudentCount || 0}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* WITHDRAWALS - Clickable */}
                <div
                  className="col-6 col-md-3"
                  onClick={() => setShowWithdrawalSummary(true)}
                  style={{ cursor: "pointer" }}
                >
                  <div
                    className="card rounded-3 p-3 shadow-sm clickable"
                    style={{
                      borderLeft: "4px solid #e74c3c",
                      transition: "all 0.2s ease",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "translateY(-2px)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "translateY(0)")
                    }
                  >
                    <div className="d-flex align-items-center">
                      <div
                        className="me-3"
                        style={{ color: "#e74c3c", fontSize: "28px" }}
                      >
                        <i className="fas fa-user-minus"></i>
                      </div>
                      <div>
                        <div className="text-uppercase fs-8 text-muted fw-bold">
                          Withdrawals
                        </div>
                        <div
                          className="h4 mb-0 fw-bold"
                          style={{ color: "#2c3e50" }}
                        >
                          {dashboardData?.summaryStatistics?.[0]
                            ?.withdrawalCount || 0}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ATTENDANCE - Normal */}
                <div className="col-6 col-md-3">
                  <div
                    className="card rounded-3 p-3 shadow-sm"
                    style={{ borderLeft: "4px solid #f39c12" }}
                  >
                    <div className="d-flex align-items-center">
                      <div
                        className="me-3"
                        style={{ color: "#f39c12", fontSize: "28px" }}
                      >
                        <i className="fas fa-user-check"></i>
                      </div>
                      <div>
                        <div className="text-uppercase fs-8 text-muted fw-bold">
                          Attendance
                        </div>

                        <div
                          className="h4 mb-0 fw-bold"
                          style={{ color: "#2c3e50" }}
                        >
                          {dashboardData?.summaryStatistics?.[0]
                            ?.attendancePercent || 0}
                          %
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* 4 Charts */}
              <div className="row g-4">
                <div className="col-lg-6">
                  <div className="card mb-3 shadow-sm">
                    <div className="card-body">
                      <h6
                        className="card-title fw-bold"
                        style={{ color: "#2c3e50", marginBottom: "20px" }}
                      >
                        Students: Enrollment by Grade
                      </h6>
                      {renderEnrollmentChart()}
                    </div>
                  </div>

                  <div className="card mb-3 shadow-sm">
                    <div className="card-body">
                      <h6
                        className="card-title fw-bold"
                        style={{ color: "#2c3e50", marginBottom: "20px" }}
                      >
                        Academics: Average Scores by Subject
                      </h6>
                      {renderAverageScores()}
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="card mb-3 shadow-sm">
                    <div className="card-body">
                      <h6
                        className="card-title fw-bold"
                        style={{ color: "#2c3e50", marginBottom: "20px" }}
                      >
                        Employees: Headcount by Department
                      </h6>
                      {renderEmployeesChart()}
                    </div>
                  </div>

                  <div className="card mb-3 shadow-sm">
                    <div className="card-body">
                      <h6
                        className="card-title fw-bold"
                        style={{ color: "#2c3e50", marginBottom: "20px" }}
                      >
                        Administration: Tickets (Open vs Closed)
                      </h6>
                      {renderTicketsChart()}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          <StudentSummaryModal
            isOpen={showStudentSummary}
            onClose={() => setShowStudentSummary(false)}
            organizationId={organizationId}
            centerId={selectedCenter?.value || 0}
            sessionId={selectedSession?.value}
            classId={selectedClass?.value}
            SessionData={sessionsData}
            cityCode={selectedCity?.code}
            stateCode={selectedProvince?.value}
          />

          <WithdrawalSummaryModal
            isOpen={showWithdrawalSummary}
            onClose={() => setShowWithdrawalSummary(false)}
            organizationId={organizationId}
            centerId={selectedCenter?.value || 0}
            sessionId={selectedSession?.value}
            classId={selectedClass?.value}
            cityCode={selectedCity?.code}
            stateCode={selectedProvince?.value}
          />

          {/* Other Tabs */}
          {activeTab === "financials" && (
            <FinanceDashboard
              filters={{
                selectedCenter,
                selectedClass,
                selectedSession,
              }}
            />
          )}
          {activeTab === "hr" && <HumanResourceDashboard />}
        </>
      )}
    </>
  );
}

export default InspSchoolManagementDashboard;
